module.exports = __webpack_public_path__ + "img/zhengchang.715d96d2.svg";